import * as myDevice from "@/helpers/deviceHelpers"

import { AuthStore } from "@/stores/authentication"
import { CommonStore } from "@/stores/common"
import Platform from 'quasar/src/plugins/Platform.js';
import { Router } from "vue-router"

import CustomerService from "@/services/customerService"

export const buildUrlCustomerSpace = (authStore: AuthStore, url: string) => {
    return `${getUrlCustomerSpace(authStore)}${url}`
}

export const getUrlCustomerSpace = (authStore: AuthStore) : string => {
    return authStore.customerSpaceUrl ?? ''
}

export const getDefaultConfiguration = (authStore: AuthStore, params: any = {}) => {
    return {
        params: params,
        headers: {
            authorization: `Bearer ${authStore.access_token}`
        }
    }
}

export const logout = (authStore: AuthStore, commonStore: CommonStore, router: Router) => {
    if (!commonStore.showLogout) {
        commonStore.showLogout = true
    } else {
        commonStore.layoutLoading = true
        CustomerService.logout({ 
            deviceId: myDevice.getDeviceId() 
        }).catch((error) => {
            console.error(error)
        }).finally(() => {
            authStore.logout(false, true)
            commonStore.layoutLoading = false
            commonStore.showLogout = false
            router.push({ name: 'login-main' }).catch((error) => console.error(error))
        })
    }
}

export const isSilentAuthAllowed = () => {
    return !Platform.is.desktop
}